// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZrA8P7UQVcUFnK7YESZIA5e_zhS_DnrY",
  authDomain: "comic-francesca.firebaseapp.com",
  projectId: "comic-francesca",
  storageBucket: "comic-francesca.appspot.com",
  messagingSenderId: "338480751038",
  appId: "1:338480751038:web:c34bb8616eaee9385a99ef",
  measurementId: "G-MZWZF68VGT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const database = getDatabase(app);

// Función para obtener la URL de la imagen
const getImageUrl = async (idImgNotes) => {
  const imageRef = ref(storage, idImgNotes); // Ajusta la ruta según sea necesario
  try {
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error("Error getting image URL: ", error);
    return null;
  }
};
//Enviar nota


export { db, storage, getImageUrl, database };